import React, { ReactNode } from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div<{ isOpen: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    z-index: 5; /* Ensure the overlay is below the modal */
    display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
    overflow: auto; /* Allow scrolling if the content overflows */
`;

const ModalContent = styled.div`
    position: fixed;
    right: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 350px;
    max-width: 90%; /* Ensure the modal is responsive */
    background-color: #fff;
    border: 1px solid ${({ theme }) => theme.popoverBorder || '#ccc'};
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    z-index: 10;
    padding: 0.5rem;
    max-height: 80%; /* Set a max height for the modal */
    overflow-y: auto; /* Enable vertical scrolling */
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    top: 1rem;
    right: 1rem;
    font-size: 1.5rem;
    color: ${({ theme }) => theme.closeIconColor || '#000'};
`;

const ContentContainer = styled.div`
    padding: 1rem 0.5rem;
`;

const ContentHeader = styled.div`
    font-weight: 600;
    font-size: 20px;
`;

const Divider = styled.div`
    height: 1px;
    background-color: ${({ theme }) => theme.dividerColor || '#ccc'};
    margin: 1rem 0; /* Space around the divider */
`;

interface GenericModalProps {
    isOpen: boolean;
    onClose: () => void;
    node: ReactNode;
    label: string;
}

const GenericModal: React.FC<GenericModalProps> = ({ isOpen, onClose, node, label }) => {
    if (!isOpen) return null;
    
    return (
        <ModalOverlay isOpen={isOpen}>
            <ModalContent>
                <CloseButton onClick={onClose} aria-label="Close modal">
                    &times; {/* Cross icon */}
                </CloseButton>
                <ContentContainer>
                    <ContentHeader>
                        {label}
                    </ContentHeader>
                    <Divider />
                    {node}
                </ContentContainer>
            </ModalContent>
        </ModalOverlay>
    );
};

export default GenericModal;
